import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Row, Col } from "react-bootstrap"
import OurStoryPageStyle from "./our-story-page.module.scss"

const BecomingFSD = () => (
    <StaticQuery query={graphql`
    query BecomingFSD{
        contentfulOurStoryPage{
            ourStoryReference{
             sectionContent3{
                  subtitle{
                    subtitle
                      }
                  sectionParagraph{
                    json
                  }
                }
            }
          }
    }
`}
render={data => (
    <div className={OurStoryPageStyle.sectionDiv}>
        <Row>
            <Col xs={12}>
                <h3 className={OurStoryPageStyle.sectionTitle}>{data.contentfulOurStoryPage.ourStoryReference.sectionContent3.subtitle.subtitle}</h3>
                <div className={OurStoryPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulOurStoryPage.ourStoryReference.sectionContent3.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default BecomingFSD